import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const InstagramCaption = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1578_126)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FEF2F2"
          />
          <path
            d="M137.948 96.9033H96.0043L72.0364 114.879V96.9033H60.0525C56.8568 96.9033 54.0605 94.1073 54.0605 90.9112V30.992C54.0605 27.7962 56.8568 25 60.0525 25H137.948C141.144 25 143.94 27.7962 143.94 30.992V90.9112C143.94 94.1073 141.144 96.9033 137.948 96.9033Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="63"
            y="61.9395"
            width="77"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="63"
            y="69.9395"
            width="61"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="63"
            y="77.9395"
            width="43"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <circle
            cx="67"
            cy="38.9395"
            r="4"
            fill="#1E1E1E"
          />
          <rect
            x="75"
            y="36.9395"
            width="38"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="117"
            y="36.9395"
            width="20"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <path
            d="M117.353 108.171H147.821L165.232 121.229V108.171H173.937C176.258 108.171 178.29 106.14 178.29 103.818V60.2921C178.29 57.9707 176.258 55.9395 173.937 55.9395H117.353C115.031 55.9395 113 57.9707 113 60.2921V103.818C113 106.14 115.031 108.171 117.353 108.171Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M142.85 94.8853C143.983 96.1109 145.914 96.1302 147.072 94.9274L159.738 81.7648C162.349 79.1532 162.929 75.0908 161.479 71.6086C158.867 66.3855 151.613 65.2248 147.55 69.2872L145.229 71.6086L142.907 69.2872C138.555 64.9346 131.59 66.0953 128.979 71.6086C127.238 75.0908 127.818 79.1532 130.72 81.7648L142.85 94.8853Z"
            fill="#FF5A4F"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M144 50.9395H54V48.9395H144V50.9395Z"
            fill="black"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <g clipPath="url(#clip1_1578_126)">
            <path
              d="M184 24.7038C188.005 24.7038 188.48 24.7188 190.062 24.7912C194.128 24.9763 196.026 26.905 196.211 30.94C196.284 32.5212 196.297 32.9963 196.297 37.0013C196.297 41.0075 196.282 41.4813 196.211 43.0625C196.025 47.0938 194.131 49.0262 190.062 49.2112C188.48 49.2837 188.007 49.2988 184 49.2988C179.995 49.2988 179.52 49.2837 177.939 49.2112C173.864 49.025 171.975 47.0875 171.79 43.0613C171.718 41.48 171.702 41.0063 171.702 37C171.702 32.995 171.719 32.5212 171.79 30.9388C171.976 26.905 173.87 24.975 177.939 24.79C179.521 24.7188 179.995 24.7038 184 24.7038ZM184 22C179.926 22 179.416 22.0175 177.816 22.09C172.369 22.34 169.341 25.3625 169.091 30.815C169.017 32.4163 169 32.9262 169 37C169 41.0737 169.017 41.585 169.09 43.185C169.34 48.6325 172.363 51.66 177.815 51.91C179.416 51.9825 179.926 52 184 52C188.074 52 188.585 51.9825 190.185 51.91C195.628 51.66 198.663 48.6375 198.909 43.185C198.983 41.585 199 41.0737 199 37C199 32.9262 198.983 32.4163 198.91 30.8162C198.665 25.3737 195.639 22.3413 190.186 22.0913C188.585 22.0175 188.074 22 184 22V22ZM184 29.2975C179.746 29.2975 176.297 32.7463 176.297 37C176.297 41.2537 179.746 44.7038 184 44.7038C188.254 44.7038 191.703 41.255 191.703 37C191.703 32.7463 188.254 29.2975 184 29.2975ZM184 42C181.239 42 179 39.7625 179 37C179 34.2387 181.239 32 184 32C186.761 32 189 34.2387 189 37C189 39.7625 186.761 42 184 42ZM192.007 27.1938C191.013 27.1938 190.206 28 190.206 28.9937C190.206 29.9875 191.013 30.7937 192.007 30.7937C193.001 30.7937 193.806 29.9875 193.806 28.9937C193.806 28 193.001 27.1938 192.007 27.1938Z"
              fill="url(#paint0_linear_1578_126)"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1578_126"
            x1="190.25"
            y1="22"
            x2="179.662"
            y2="50.1616"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5E5CCB" />
            <stop
              offset="0.18214"
              stopColor="#8D40B7"
            />
            <stop
              offset="0.431696"
              stopColor="#DA2E7C"
            />
            <stop
              offset="0.753527"
              stopColor="#F15544"
            />
            <stop
              offset="1"
              stopColor="#FECA66"
            />
          </linearGradient>
          <clipPath id="clip0_1578_126">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1578_126">
            <rect
              width="30"
              height="30"
              fill="white"
              transform="translate(169 22)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
